import React from "react";
import { Check } from "lucide-react";

// Soft-guidance workflow tracker for an RFQ. Shows the ordered steps, auto-ticks
// completed ones, and wraps the current step in a pulsing "circling" ring.
export default function RFQWorkflow({ steps, currentIndex, title = "RFQ Workflow" }) {
  const nextLabel = currentIndex >= 0 ? steps[currentIndex]?.label : null;
  return (
    <div className="mb-6 rounded-lg border border-border bg-white px-5 py-4" data-testid="rfq-workflow">
      <div className="mb-3 flex items-center justify-between">
        <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{title}</div>
        {nextLabel && (
          <div className="text-xs text-muted-foreground" data-testid="rfq-workflow-next">
            Next: <span className="font-semibold text-brand">{nextLabel}</span>
          </div>
        )}
      </div>
      <ol className="flex flex-wrap items-center gap-y-3">
        {steps.map((s, i) => {
          const done = s.done;
          const current = i === currentIndex;
          return (
            <li key={s.key} className="flex items-center">
              <button
                type="button"
                onClick={s.onClick}
                data-testid={`wf-step-${s.key}`}
                data-current={current ? "true" : undefined}
                className="group relative z-10 flex items-center gap-2"
              >
                <span className="relative inline-flex h-7 w-7 items-center justify-center">
                  {current && <span className="pointer-events-none absolute inline-flex h-full w-full animate-ping rounded-full bg-brand/40" />}
                  <span
                    className={`relative inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold transition-colors ${
                      done
                        ? "bg-ok text-white"
                        : current
                        ? "bg-brand text-white ring-4 ring-brand/30 animate-pulse"
                        : "bg-steel-100 text-steel-500 group-hover:bg-steel-200"
                    }`}
                  >
                    {done ? <Check className="h-4 w-4" /> : i + 1}
                  </span>
                </span>
                <span
                  className={`whitespace-nowrap text-sm font-medium ${
                    current ? "text-brand" : done ? "text-slate-700" : "text-muted-foreground"
                  }`}
                >
                  {s.label}
                </span>
              </button>
              {i < steps.length - 1 && <span className={`pointer-events-none mx-2 h-px w-6 shrink-0 ${done ? "bg-ok/40" : "bg-border"}`} />}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
